// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file eco_inspect.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { File, FileJson, FileUpload, FileUploadJson, FileUploadType, FileUploadTypeJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { EmptyMessageRequestSchema, IdRequestSchema, ListFilter, ListFilterJson, ListInfo, ListInfoJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GovGeoAccessListSchema } from "./gov_geo_access_pb";
import { file_gov_geo_access } from "./gov_geo_access_pb";
import type { OrganizationListSchema } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file eco_inspect.proto.
 */
export const file_eco_inspect: GenFile = /*@__PURE__*/
  fileDesc("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", [file_file_upload, file_general, file_google_protobuf_timestamp, file_gov_geo_access, file_organization]);

/**
 * ---------------------------------------------------------------------------
 * Reasons — a curated, growable pick-list (dynamic). Seeded with the ~10 known
 * cases; the eco officer can add more via CreateEcoInspectReason ("Other").
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspectReason
 */
export type EcoInspectReason = Message<"raccoonai.EcoInspectReason"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string reason = 2;
   */
  reason: string;
};

/**
 * ---------------------------------------------------------------------------
 * Reasons — a curated, growable pick-list (dynamic). Seeded with the ~10 known
 * cases; the eco officer can add more via CreateEcoInspectReason ("Other").
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspectReason
 */
export type EcoInspectReasonJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message raccoonai.EcoInspectReason.
 * Use `create(EcoInspectReasonSchema)` to create a new message.
 */
export const EcoInspectReasonSchema: GenMessage<EcoInspectReason, {jsonType: EcoInspectReasonJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 0);

/**
 * @generated from message raccoonai.EcoInspectReasonCreate
 */
export type EcoInspectReasonCreate = Message<"raccoonai.EcoInspectReasonCreate"> & {
  /**
   * @generated from field: required string reason = 1;
   */
  reason: string;
};

/**
 * @generated from message raccoonai.EcoInspectReasonCreate
 */
export type EcoInspectReasonCreateJson = {
  /**
   * @generated from field: required string reason = 1;
   */
  reason?: string;
};

/**
 * Describes the message raccoonai.EcoInspectReasonCreate.
 * Use `create(EcoInspectReasonCreateSchema)` to create a new message.
 */
export const EcoInspectReasonCreateSchema: GenMessage<EcoInspectReasonCreate, {jsonType: EcoInspectReasonCreateJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 1);

/**
 * @generated from message raccoonai.EcoInspectReasonList
 */
export type EcoInspectReasonList = Message<"raccoonai.EcoInspectReasonList"> & {
  /**
   * @generated from field: repeated raccoonai.EcoInspectReason reasons = 1;
   */
  reasons: EcoInspectReason[];
};

/**
 * @generated from message raccoonai.EcoInspectReasonList
 */
export type EcoInspectReasonListJson = {
  /**
   * @generated from field: repeated raccoonai.EcoInspectReason reasons = 1;
   */
  reasons?: EcoInspectReasonJson[];
};

/**
 * Describes the message raccoonai.EcoInspectReasonList.
 * Use `create(EcoInspectReasonListSchema)` to create a new message.
 */
export const EcoInspectReasonListSchema: GenMessage<EcoInspectReasonList, {jsonType: EcoInspectReasonListJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 2);

/**
 * ---------------------------------------------------------------------------
 * Contacts — an eco-owned contact book keyed by service_provider_name (its own
 * table + join to eco_inspect). Managed via the CRUD RPCs below; independent of
 * the platform Contact/permify.
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspectContact
 */
export type EcoInspectContact = Message<"raccoonai.EcoInspectContact"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string contact_name = 3 [json_name = "contact_name"];
   */
  contactName: string;

  /**
   * @generated from field: optional string contact_phone = 4 [json_name = "contact_phone"];
   */
  contactPhone: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * ---------------------------------------------------------------------------
 * Contacts — an eco-owned contact book keyed by service_provider_name (its own
 * table + join to eco_inspect). Managed via the CRUD RPCs below; independent of
 * the platform Contact/permify.
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspectContact
 */
export type EcoInspectContactJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string contact_name = 3 [json_name = "contact_name"];
   */
  contact_name?: string;

  /**
   * @generated from field: optional string contact_phone = 4 [json_name = "contact_phone"];
   */
  contact_phone?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.EcoInspectContact.
 * Use `create(EcoInspectContactSchema)` to create a new message.
 */
export const EcoInspectContactSchema: GenMessage<EcoInspectContact, {jsonType: EcoInspectContactJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 3);

/**
 * @generated from message raccoonai.EcoInspectContactCreate
 */
export type EcoInspectContactCreate = Message<"raccoonai.EcoInspectContactCreate"> & {
  /**
   * @generated from field: optional string service_provider_name = 1 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string contact_name = 2 [json_name = "contact_name"];
   */
  contactName: string;

  /**
   * @generated from field: optional string contact_phone = 3 [json_name = "contact_phone"];
   */
  contactPhone: string;
};

/**
 * @generated from message raccoonai.EcoInspectContactCreate
 */
export type EcoInspectContactCreateJson = {
  /**
   * @generated from field: optional string service_provider_name = 1 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string contact_name = 2 [json_name = "contact_name"];
   */
  contact_name?: string;

  /**
   * @generated from field: optional string contact_phone = 3 [json_name = "contact_phone"];
   */
  contact_phone?: string;
};

/**
 * Describes the message raccoonai.EcoInspectContactCreate.
 * Use `create(EcoInspectContactCreateSchema)` to create a new message.
 */
export const EcoInspectContactCreateSchema: GenMessage<EcoInspectContactCreate, {jsonType: EcoInspectContactCreateJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 4);

/**
 * @generated from message raccoonai.EcoInspectContactUpdate
 */
export type EcoInspectContactUpdate = Message<"raccoonai.EcoInspectContactUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string contact_name = 3 [json_name = "contact_name"];
   */
  contactName: string;

  /**
   * @generated from field: optional string contact_phone = 4 [json_name = "contact_phone"];
   */
  contactPhone: string;
};

/**
 * @generated from message raccoonai.EcoInspectContactUpdate
 */
export type EcoInspectContactUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string contact_name = 3 [json_name = "contact_name"];
   */
  contact_name?: string;

  /**
   * @generated from field: optional string contact_phone = 4 [json_name = "contact_phone"];
   */
  contact_phone?: string;
};

/**
 * Describes the message raccoonai.EcoInspectContactUpdate.
 * Use `create(EcoInspectContactUpdateSchema)` to create a new message.
 */
export const EcoInspectContactUpdateSchema: GenMessage<EcoInspectContactUpdate, {jsonType: EcoInspectContactUpdateJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 5);

/**
 * @generated from message raccoonai.EcoInspectContactList
 */
export type EcoInspectContactList = Message<"raccoonai.EcoInspectContactList"> & {
  /**
   * @generated from field: repeated raccoonai.EcoInspectContact contacts = 1;
   */
  contacts: EcoInspectContact[];
};

/**
 * @generated from message raccoonai.EcoInspectContactList
 */
export type EcoInspectContactListJson = {
  /**
   * @generated from field: repeated raccoonai.EcoInspectContact contacts = 1;
   */
  contacts?: EcoInspectContactJson[];
};

/**
 * Describes the message raccoonai.EcoInspectContactList.
 * Use `create(EcoInspectContactListSchema)` to create a new message.
 */
export const EcoInspectContactListSchema: GenMessage<EcoInspectContactList, {jsonType: EcoInspectContactListJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 6);

/**
 * @generated from message raccoonai.EcoInspectContactRequest
 */
export type EcoInspectContactRequest = Message<"raccoonai.EcoInspectContactRequest"> & {
  /**
   * Restrict to a given service provider's contacts (the default-contacts picker).
   *
   * @generated from field: optional string service_provider_name = 1 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * Typeahead: case-insensitive substring matched against contact name or phone.
   *
   * @generated from field: optional string query = 2;
   */
  query: string;

  /**
   * Max rows to return (default 50, capped at 100).
   *
   * @generated from field: optional uint32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message raccoonai.EcoInspectContactRequest
 */
export type EcoInspectContactRequestJson = {
  /**
   * Restrict to a given service provider's contacts (the default-contacts picker).
   *
   * @generated from field: optional string service_provider_name = 1 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * Typeahead: case-insensitive substring matched against contact name or phone.
   *
   * @generated from field: optional string query = 2;
   */
  query?: string;

  /**
   * Max rows to return (default 50, capped at 100).
   *
   * @generated from field: optional uint32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message raccoonai.EcoInspectContactRequest.
 * Use `create(EcoInspectContactRequestSchema)` to create a new message.
 */
export const EcoInspectContactRequestSchema: GenMessage<EcoInspectContactRequest, {jsonType: EcoInspectContactRequestJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 7);

/**
 * Distinct service-provider names seen across inspections (GROUP BY), for the picker.
 *
 * @generated from message raccoonai.EcoInspectServiceProviderList
 */
export type EcoInspectServiceProviderList = Message<"raccoonai.EcoInspectServiceProviderList"> & {
  /**
   * @generated from field: repeated string service_provider_names = 1 [json_name = "service_provider_names"];
   */
  serviceProviderNames: string[];
};

/**
 * Distinct service-provider names seen across inspections (GROUP BY), for the picker.
 *
 * @generated from message raccoonai.EcoInspectServiceProviderList
 */
export type EcoInspectServiceProviderListJson = {
  /**
   * @generated from field: repeated string service_provider_names = 1 [json_name = "service_provider_names"];
   */
  service_provider_names?: string[];
};

/**
 * Describes the message raccoonai.EcoInspectServiceProviderList.
 * Use `create(EcoInspectServiceProviderListSchema)` to create a new message.
 */
export const EcoInspectServiceProviderListSchema: GenMessage<EcoInspectServiceProviderList, {jsonType: EcoInspectServiceProviderListJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 8);

/**
 * ---------------------------------------------------------------------------
 * Eco inspection
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspect
 */
export type EcoInspect = Message<"raccoonai.EcoInspect"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * uuid unique generated by us uuid per record
   *
   * @generated from field: required string uuid = 2;
   */
  uuid: string;

  /**
   * @generated from field: optional string area_name = 3 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: optional string service_provider_name = 4 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string location = 5;
   */
  location: string;

  /**
   * Chosen reason, stored as a text snapshot (stable even if the reason list changes).
   *
   * @generated from field: optional string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: repeated raccoonai.FileUpload files = 7;
   */
  files: FileUpload[];

  /**
   * @generated from field: required raccoonai.EcoInspectStatus status = 8;
   */
  status: EcoInspectStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 9 [json_name = "report_date"];
   */
  reportDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp provider_report_uploaded_at = 10 [json_name = "provider_report_uploaded_at"];
   */
  providerReportUploadedAt?: Timestamp;

  /**
   * @generated from field: optional uint64 author_id = 11 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 12 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string comment = 14;
   */
  comment: string;

  /**
   * Contacts linked to this inspection (via the eco_inspect_contact_link join table).
   *
   * @generated from field: repeated raccoonai.EcoInspectContact contacts = 15;
   */
  contacts: EcoInspectContact[];

  /**
   * @generated from field: optional string contact_name = 17 [json_name = "contact_name"];
   */
  contactName: string;

  /**
   * @generated from field: optional string contact_phone = 18 [json_name = "contact_phone"];
   */
  contactPhone: string;

  /**
   * @generated from field: optional uint64 containers_affected = 19 [json_name = "containers_affected"];
   */
  containersAffected: bigint;

  /**
   * Stamped when the eco officer moves the inspection into REVIEWED; cleared if it
   * leaves REVIEWED again. Non-null iff the inspection is currently REVIEWED.
   *
   * @generated from field: optional google.protobuf.Timestamp confirmed_at = 20 [json_name = "confirmed_at"];
   */
  confirmedAt?: Timestamp;
};

/**
 * ---------------------------------------------------------------------------
 * Eco inspection
 * ---------------------------------------------------------------------------
 *
 * @generated from message raccoonai.EcoInspect
 */
export type EcoInspectJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * uuid unique generated by us uuid per record
   *
   * @generated from field: required string uuid = 2;
   */
  uuid?: string;

  /**
   * @generated from field: optional string area_name = 3 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: optional string service_provider_name = 4 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string location = 5;
   */
  location?: string;

  /**
   * Chosen reason, stored as a text snapshot (stable even if the reason list changes).
   *
   * @generated from field: optional string reason = 6;
   */
  reason?: string;

  /**
   * @generated from field: repeated raccoonai.FileUpload files = 7;
   */
  files?: FileUploadJson[];

  /**
   * @generated from field: required raccoonai.EcoInspectStatus status = 8;
   */
  status?: EcoInspectStatusJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 9 [json_name = "report_date"];
   */
  report_date?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp provider_report_uploaded_at = 10 [json_name = "provider_report_uploaded_at"];
   */
  provider_report_uploaded_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 author_id = 11 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 12 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 13 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: optional string comment = 14;
   */
  comment?: string;

  /**
   * Contacts linked to this inspection (via the eco_inspect_contact_link join table).
   *
   * @generated from field: repeated raccoonai.EcoInspectContact contacts = 15;
   */
  contacts?: EcoInspectContactJson[];

  /**
   * @generated from field: optional string contact_name = 17 [json_name = "contact_name"];
   */
  contact_name?: string;

  /**
   * @generated from field: optional string contact_phone = 18 [json_name = "contact_phone"];
   */
  contact_phone?: string;

  /**
   * @generated from field: optional uint64 containers_affected = 19 [json_name = "containers_affected"];
   */
  containers_affected?: string;

  /**
   * Stamped when the eco officer moves the inspection into REVIEWED; cleared if it
   * leaves REVIEWED again. Non-null iff the inspection is currently REVIEWED.
   *
   * @generated from field: optional google.protobuf.Timestamp confirmed_at = 20 [json_name = "confirmed_at"];
   */
  confirmed_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.EcoInspect.
 * Use `create(EcoInspectSchema)` to create a new message.
 */
export const EcoInspectSchema: GenMessage<EcoInspect, {jsonType: EcoInspectJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 9);

/**
 * @generated from message raccoonai.EcoInspectList
 */
export type EcoInspectList = Message<"raccoonai.EcoInspectList"> & {
  /**
   * @generated from field: repeated raccoonai.EcoInspect inspections = 1;
   */
  inspections: EcoInspect[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.EcoInspectList
 */
export type EcoInspectListJson = {
  /**
   * @generated from field: repeated raccoonai.EcoInspect inspections = 1;
   */
  inspections?: EcoInspectJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.EcoInspectList.
 * Use `create(EcoInspectListSchema)` to create a new message.
 */
export const EcoInspectListSchema: GenMessage<EcoInspectList, {jsonType: EcoInspectListJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 10);

/**
 * @generated from message raccoonai.EcoInspectCreate
 */
export type EcoInspectCreate = Message<"raccoonai.EcoInspectCreate"> & {
  /**
   * @generated from field: optional string area_name = 1 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string location = 3;
   */
  location: string;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: repeated raccoonai.EcoInspectMediaUpload files = 5;
   */
  files: EcoInspectMediaUpload[];

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 6 [json_name = "report_date"];
   */
  reportDate?: Timestamp;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 7;
   */
  status: EcoInspectStatus;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment: string;

  /**
   * Contacts to link (ids from the eco_inspect_contact table).
   *
   * @generated from field: repeated uint64 contact_ids = 9 [json_name = "contact_ids"];
   */
  contactIds: bigint[];
};

/**
 * @generated from message raccoonai.EcoInspectCreate
 */
export type EcoInspectCreateJson = {
  /**
   * @generated from field: optional string area_name = 1 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string location = 3;
   */
  location?: string;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason?: string;

  /**
   * @generated from field: repeated raccoonai.EcoInspectMediaUpload files = 5;
   */
  files?: EcoInspectMediaUploadJson[];

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 6 [json_name = "report_date"];
   */
  report_date?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 7;
   */
  status?: EcoInspectStatusJson;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment?: string;

  /**
   * Contacts to link (ids from the eco_inspect_contact table).
   *
   * @generated from field: repeated uint64 contact_ids = 9 [json_name = "contact_ids"];
   */
  contact_ids?: string[];
};

/**
 * Describes the message raccoonai.EcoInspectCreate.
 * Use `create(EcoInspectCreateSchema)` to create a new message.
 */
export const EcoInspectCreateSchema: GenMessage<EcoInspectCreate, {jsonType: EcoInspectCreateJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 11);

/**
 * @generated from message raccoonai.EcoInspectUpdate
 */
export type EcoInspectUpdate = Message<"raccoonai.EcoInspectUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string area_name = 2 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: optional string service_provider_name = 3 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional string location = 4;
   */
  location: string;

  /**
   * @generated from field: optional string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 6 [json_name = "report_date"];
   */
  reportDate?: Timestamp;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 7;
   */
  status: EcoInspectStatus;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment: string;

  /**
   * When present, replaces the linked contacts with these ids.
   *
   * @generated from field: repeated uint64 contact_ids = 9 [json_name = "contact_ids"];
   */
  contactIds: bigint[];

  /**
   * @generated from field: optional uint64 containers_affected = 10 [json_name = "containers_affected"];
   */
  containersAffected: bigint;
};

/**
 * @generated from message raccoonai.EcoInspectUpdate
 */
export type EcoInspectUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string area_name = 2 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: optional string service_provider_name = 3 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional string location = 4;
   */
  location?: string;

  /**
   * @generated from field: optional string reason = 5;
   */
  reason?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date = 6 [json_name = "report_date"];
   */
  report_date?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 7;
   */
  status?: EcoInspectStatusJson;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment?: string;

  /**
   * When present, replaces the linked contacts with these ids.
   *
   * @generated from field: repeated uint64 contact_ids = 9 [json_name = "contact_ids"];
   */
  contact_ids?: string[];

  /**
   * @generated from field: optional uint64 containers_affected = 10 [json_name = "containers_affected"];
   */
  containers_affected?: string;
};

/**
 * Describes the message raccoonai.EcoInspectUpdate.
 * Use `create(EcoInspectUpdateSchema)` to create a new message.
 */
export const EcoInspectUpdateSchema: GenMessage<EcoInspectUpdate, {jsonType: EcoInspectUpdateJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 12);

/**
 * EcoInspectMediaUpload appends media (images or videos) to a row.
 *
 * @generated from message raccoonai.EcoInspectMediaUpload
 */
export type EcoInspectMediaUpload = Message<"raccoonai.EcoInspectMediaUpload"> & {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type: FileUploadType;

  /**
   * @generated from field: repeated raccoonai.File files = 3;
   */
  files: File[];

  /**
   * @generated from field: optional uint64 containers_affected = 4 [json_name = "containers_affected"];
   */
  containersAffected: bigint;
};

/**
 * EcoInspectMediaUpload appends media (images or videos) to a row.
 *
 * @generated from message raccoonai.EcoInspectMediaUpload
 */
export type EcoInspectMediaUploadJson = {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type?: FileUploadTypeJson;

  /**
   * @generated from field: repeated raccoonai.File files = 3;
   */
  files?: FileJson[];

  /**
   * @generated from field: optional uint64 containers_affected = 4 [json_name = "containers_affected"];
   */
  containers_affected?: string;
};

/**
 * Describes the message raccoonai.EcoInspectMediaUpload.
 * Use `create(EcoInspectMediaUploadSchema)` to create a new message.
 */
export const EcoInspectMediaUploadSchema: GenMessage<EcoInspectMediaUpload, {jsonType: EcoInspectMediaUploadJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 13);

/**
 * @generated from message raccoonai.EcoInspectListRequest
 */
export type EcoInspectListRequest = Message<"raccoonai.EcoInspectListRequest"> & {
  /**
   * @generated from field: optional string area_name = 1 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 3;
   */
  status: EcoInspectStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date_from = 4 [json_name = "report_date_from"];
   */
  reportDateFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date_to = 5 [json_name = "report_date_to"];
   */
  reportDateTo?: Timestamp;

  /**
   * @generated from field: optional string location = 6;
   */
  location: string;

  /**
   * @generated from field: optional string reason = 7;
   */
  reason: string;

  /**
   * @generated from field: optional string search = 8;
   */
  search: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.EcoInspectListRequest
 */
export type EcoInspectListRequestJson = {
  /**
   * @generated from field: optional string area_name = 1 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: optional string service_provider_name = 2 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * @generated from field: optional raccoonai.EcoInspectStatus status = 3;
   */
  status?: EcoInspectStatusJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date_from = 4 [json_name = "report_date_from"];
   */
  report_date_from?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp report_date_to = 5 [json_name = "report_date_to"];
   */
  report_date_to?: TimestampJson;

  /**
   * @generated from field: optional string location = 6;
   */
  location?: string;

  /**
   * @generated from field: optional string reason = 7;
   */
  reason?: string;

  /**
   * @generated from field: optional string search = 8;
   */
  search?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.EcoInspectListRequest.
 * Use `create(EcoInspectListRequestSchema)` to create a new message.
 */
export const EcoInspectListRequestSchema: GenMessage<EcoInspectListRequest, {jsonType: EcoInspectListRequestJson}> = /*@__PURE__*/
  messageDesc(file_eco_inspect, 14);

/**
 * EcoInspectStatus tracks the lifecycle of an inspection as the city eco officer
 * drives it from "just logged" through "provider must fix" to "resolved".
 *
 * @generated from enum raccoonai.EcoInspectStatus
 */
export enum EcoInspectStatus {
  /**
   * @generated from enum value: ECO_INSPECT_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: ECO_INSPECT_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: ECO_INSPECT_STATUS_WAITING_FOR_RESPONSE = 2;
   */
  WAITING_FOR_RESPONSE = 2,

  /**
   * @generated from enum value: ECO_INSPECT_STATUS_NEED_REVIEW = 3;
   */
  NEED_REVIEW = 3,

  /**
   * @generated from enum value: ECO_INSPECT_STATUS_REVIEWED = 4;
   */
  REVIEWED = 4,
}

/**
 * EcoInspectStatus tracks the lifecycle of an inspection as the city eco officer
 * drives it from "just logged" through "provider must fix" to "resolved".
 *
 * @generated from enum raccoonai.EcoInspectStatus
 */
export type EcoInspectStatusJson = "ECO_INSPECT_STATUS_UNDEFINED" | "ECO_INSPECT_STATUS_CREATED" | "ECO_INSPECT_STATUS_WAITING_FOR_RESPONSE" | "ECO_INSPECT_STATUS_NEED_REVIEW" | "ECO_INSPECT_STATUS_REVIEWED";

/**
 * Describes the enum raccoonai.EcoInspectStatus.
 */
export const EcoInspectStatusSchema: GenEnum<EcoInspectStatus, EcoInspectStatusJson> = /*@__PURE__*/
  enumDesc(file_eco_inspect, 0);

/**
 * @generated from service raccoonai.EcoInspectService
 */
export const EcoInspectService: GenService<{
  /**
   * Pick-list helpers for the front end.
   *
   * @generated from rpc raccoonai.EcoInspectService.GetGovGeoAreaNames
   */
  getGovGeoAreaNames: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof GovGeoAccessListSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.GetGovServiceProviders
   */
  getGovServiceProviders: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.ListServiceProviderNames
   */
  listServiceProviderNames: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof EcoInspectServiceProviderListSchema;
  },
  /**
   * Reasons (dynamic pick-list).
   *
   * @generated from rpc raccoonai.EcoInspectService.ListEcoInspectReasons
   */
  listEcoInspectReasons: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof EcoInspectReasonListSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.CreateEcoInspectReason
   */
  createEcoInspectReason: {
    methodKind: "unary";
    input: typeof EcoInspectReasonCreateSchema;
    output: typeof EcoInspectReasonSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.DeleteEcoInspectReason
   */
  deleteEcoInspectReason: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Contacts (eco-owned contact book; default contacts per service provider).
   *
   * @generated from rpc raccoonai.EcoInspectService.ListEcoInspectContacts
   */
  listEcoInspectContacts: {
    methodKind: "unary";
    input: typeof EcoInspectContactRequestSchema;
    output: typeof EcoInspectContactListSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.CreateEcoInspectContact
   */
  createEcoInspectContact: {
    methodKind: "unary";
    input: typeof EcoInspectContactCreateSchema;
    output: typeof EcoInspectContactSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.UpdateEcoInspectContact
   */
  updateEcoInspectContact: {
    methodKind: "unary";
    input: typeof EcoInspectContactUpdateSchema;
    output: typeof EcoInspectContactSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.DeleteEcoInspectContact
   */
  deleteEcoInspectContact: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Eco inspection.
   *
   * @generated from rpc raccoonai.EcoInspectService.CreateEcoInspect
   */
  createEcoInspect: {
    methodKind: "unary";
    input: typeof EcoInspectCreateSchema;
    output: typeof EcoInspectSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.UpdateEcoInspect
   */
  updateEcoInspect: {
    methodKind: "unary";
    input: typeof EcoInspectUpdateSchema;
    output: typeof EcoInspectSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.GetEcoInspect
   */
  getEcoInspect: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EcoInspectSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.ListEcoInspects
   */
  listEcoInspects: {
    methodKind: "unary";
    input: typeof EcoInspectListRequestSchema;
    output: typeof EcoInspectListSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.DeleteEcoInspect
   */
  deleteEcoInspect: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.EcoInspectService.UploadEcoInspectMedia
   */
  uploadEcoInspectMedia: {
    methodKind: "unary";
    input: typeof EcoInspectMediaUploadSchema;
    output: typeof EcoInspectSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_eco_inspect, 0);

